import DefaultLayout from '../layout/DefaultLayout';
import Breadcrumb from '../components/Breadcrumbs/Breadcrumb';
import StudentsListTable from '../components/Students/StudentsListTable';

const StudentsList = () => {
  return (
    <DefaultLayout>
      <Breadcrumb pageName="Students List" />
      <div className="flex flex-col gap-10">
        <StudentsListTable />
      </div>
    </DefaultLayout>
  );
};

export default StudentsList;
